import { ITip } from '@src/components/ui/Tip/interfaces';
import { BMI_STATUS, IBmiStatus, TAG_TYPE } from '@src/constants';

export const feetInchesToCm = (
  feet: number | undefined,
  inches: number | undefined,
) => {
  if (!feet) return 0;
  const totalInches = Number(feet) * 12 + Number(inches ?? 0);
  return Math.round(totalInches * 2.54);
};

export const getStatusByBMI = (bmi: number): IBmiStatus => {
  if (bmi >= 30) return BMI_STATUS.OBESE;
  if (bmi >= 25 && bmi <= 29.999) return BMI_STATUS.OVERWEIGHT;
  return BMI_STATUS.NORMAL;
};

export const getBodyFatByStatus = (status: IBmiStatus): string => {
  if (status === BMI_STATUS.OBESE) return '>30%';
  if (status === BMI_STATUS.OVERWEIGHT) return '>25%';
  return '15-24%';
};

export const getStatusByPercent = (
  percent: number | undefined,
): ITip['type'] => {
  if (!percent) return;
  if (percent <= 5) return TAG_TYPE.EASY;
  if (percent > 20) return TAG_TYPE.CHALLENGING;
  if (percent > 5 && percent < 10) return TAG_TYPE.REALISTIC;
  if (percent >= 10 && percent <= 20) return TAG_TYPE.HEALTH;
};

export const lbsToKg = (lbs: number | undefined) =>
  !lbs ? 0 : Math.round(lbs * 0.453592);

export const kgToLbs = (kg: number | undefined) =>
  !kg ? 0 : Math.round(kg / 0.453592);

export const calculateBMI = (height: number, currentWeight: number): number => {
  height = Number(height) / 100;
  const bmi = currentWeight / (height * height);

  return Number(bmi.toFixed(2));
};

export const decodeHtml = (html: string) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};
